import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OrdemComponent } from './modules/ordem/ordem.component';
import { CadastrarOrdemComponent } from './modules/ordem/cadastrar-ordem/cadastrar-ordem.component';
import { ListarOrdemComponent } from './modules/ordem/listar-ordem/listar-ordem.component';
import { LoginComponent } from "./modules/login/login/login.component";
import { ErrorPageComponent } from './modules/comum/error-page/error-page.component';
import { RouteGuardService } from './core/guard/route-guard.service';
import { DadosOrdemComponent } from './modules/ordem/dados-ordem/dados-ordem.component';
import { OutrasSolicitacaoComponent } from './modules/ordem/cadastrar-ordem/outras-solicitacao/outras-solicitacao.component';
import { ErrorAuthComponent } from './modules/comum/error-auth/error-auth.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/ordem',
    pathMatch: 'full'
  },
  {
    path: 'ordem',
    component: OrdemComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'cadastrar-ordem',
    component: CadastrarOrdemComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'listar-ordem',
    component: ListarOrdemComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'cadastrar-ordem-outros',
    component: OutrasSolicitacaoComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'listar-ordem/:nroProcesso',
    component: ListarOrdemComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'detalhar-ordem/:nroProcesso',
    component: DadosOrdemComponent,
    canActivate:[RouteGuardService]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'error-auth',
    component: ErrorAuthComponent,
  },
  {
    path: 'error',
    component: ErrorPageComponent
  },
  {
    path: '**',
    component: ErrorPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    canceledNavigationResolution: 'computed',
    paramsInheritanceStrategy: 'always',
    urlUpdateStrategy: 'deferred',
    // titleStrategy: MyCustomTitleStrategy,
    // urlHandlingStrategy: customUrlHandlingStrategy,
    // malformedUriErrorHandler: (error, serializer, url) => { ... }
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
